<template>
  <div class="ac-content-wrapper">
    <div class="header" style="font-weight: 500;">
      Upload App Icon
    </div>
    <div class="sub-header">
      App icons typically update on devices after 3-10 business days.
    </div>
    <div
      v-if="appIconPreview"
      class="ac-preview-container"
    >
      <div class="ac-logo-preview-container">
        <img
          class="image-preview"
          :src="appIconPreview"
        >
      </div>
      <div
        v-if="adminRole === 'admin'"
        class="flex-row"
      >
        <div class="button-dropbox-container">
          <input
            id="logo-upload-container"
            ref="logoRef"
            type="file"
            class="db-input"
            accept="image/*"
            @change="selectedImage('appIcon', $event.target.files)"
          >
          <button class="ac-change-image-btn">
            Change Image
          </button>
        </div>
      </div>
    </div>
    <div
      v-if="!appIconPreview"
      class="sub-header"
    >
      Your icon must be 1024 x 1024 pixels. Use a full-bleed, non-transparent image for the background layer of your icon.
    </div>
    <div
      v-if="!appIconPreview"
      class="ac-example-container"
    >
      <img
        src="@shared/assets/img/setting/icon-example.svg"
        class="example-img"
        alt="Example"
      >
      <div class="flex-column align-center">
        <img
          src="@shared/assets/img/setting/app-logo.svg"
          class="smac-logo-img"
          alt="Example"
        >
        <div class="ac-example-text">
          Example
        </div>
      </div>
    </div>
    <form
      v-if="!appIconPreview"
      class="dropbox-form"
      enctype="multipart/form-data"
    >
      <div class="dropbox-container">
        <input
          id="logo-upload-container"
          ref="logoRef"
          type="file"
          class="db-input"
          accept="image/*"
          @change="selectedImage('appIcon', $event.target.files)"
        >
        <div
          v-if="!errorObj.appIconErr"
          class="db-header"
        >
          <img
            src="@shared/assets/img/general/upload-grey.png"
            alt="Upload"
            class="upload-icon"
          >
          <span>
            <span class="blue-underline">Click to upload</span>
            or drag and drop
          </span>
          <span>
            PNG, JPG
          </span>
        </div>
        <div
          v-else
          class="db-error-container"
        >
          <div class="db-error">
            {{ errorObj.appIconErr }}
          </div>
          <div>
            <span class="blue-underline">Click to upload</span>
            or drag and drop
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  name: 'AppIcon',
  props: {
    adminRole: String,
    selectedImage: Function,
    appIconPreview: String,
    errorObj: Object,
  },
};
</script>
